<template>
  <section>
    <div v-if="step == 1">
      <div v-for="s in course_groups" :key="s.id">
        <div class="flex justify-between items-center py-3">
          <div class="flex flex-col">
            <p>
              <span class="text-gray-600 font-bold">Start: </span>
              <span class="font-bold p-1"
                >
                {{ getFormattedDate(s.course_start_date, s.timezone, 'MMMM DD, YYYY') }}
              </span>
            </p>
            <p>
              <span class="text-gray-600 font-bold">End: </span>
              <span class="font-bold p-3"
                >
                {{ getFormattedDate(s.course_end_date, s.timezone, 'MMMM DD, YYYY') }}
              </span>
            </p>
          </div>
          <button
            type="button"
            class="uppercase tracking-wide bg-green-light rounded-lg text-white ring-gray-300 py-2 px-4 ring-1"
            @click="handleSelectClick(s.group_id)"
          >
            See Details
          </button>
        </div>
      </div>
      <p
        class="text-sm text-center py-2 text-gray-dark"
        v-if="course_groups && course_groups.length == 0"
      >
        No slots available or scheduled for this class
      </p>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    data: Object,
    course_groups: Array,
    handleSelectSlotOnMobileDevice: Function,
    type: String,
    selectedCourseSlotId: Number,
    handleFooterPopper: Function,
    handleSelectOpenOnPopper: Function,
  },
  data() {
    return {
      step: 1,
      sessions_group: [],
    };
  },
  methods: {
    handleCancel() {
      this.step = 1;
      if (this.handleSelectOpenOnPopper) {
        this.handleSelectOpenOnPopper(false);
      }
      this.$emit("show-courses", true);
    },

    handleSelectClick(id) {
      if (
        this.type === "slotOnMobileDevice" &&
        this.handleSelectSlotOnMobileDevice
      ) {
        this.handleSelectSlotOnMobileDevice(id, true);
      } else {
        if (this.handleSelectOpenOnPopper) {
          this.handleSelectOpenOnPopper(true);
        }
        const data = this.data.sessions_group.available;
        for (var key in data) {
          this.sessions_group = data[id];
        }
        this.step = 2;
        //  this.$emit("hide-courses", false);
        this.$emit("sessions-group", this.sessions_group);
      }
    },
  },
  mounted() {
    if (this.selectedCourseSlotId) {
      this.handleSelectClick(this.selectedCourseSlotId);
    }
  },
};
</script>